import { Business } from '@mui/icons-material';
import { useMemo } from 'react';

import { Maybe } from 'shared/graphql';
import { generateOrganizationRoute } from 'shared/routes';

import { AuthorAvatar, AuthorAvatarProps } from './AuthorAvatar';

interface Organization {
  id?: Maybe<string>;
  name?: Maybe<string>;
  logo?: Maybe<{ downloadUrl?: Maybe<string> }>;
}

interface Props extends Omit<AuthorAvatarProps, 'name' | 'source' | 'route'> {
  organization: Organization | undefined | null;
}

export function OrganizationAvatar({ organization, ...props }: Props) {
  const source = organization?.logo?.downloadUrl ?? undefined;
  const name = organization?.name;

  const route = useMemo(() => {
    return generateOrganizationRoute(organization?.id);
  }, [organization]);

  return (
    <AuthorAvatar
      {...props}
      source={source}
      name={name}
      route={route}
      disabled={!organization || props.disabled}
    >
      <Business fontSize="inherit" />
    </AuthorAvatar>
  );
}
